const Speak = async (text, func, updateLiveText) => {
  try {
    const response = await fetch("https://api.openai.com/v1/audio/speech", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${process.env.REACT_APP_OPEN_AI_KEY}`,
      },
      body: JSON.stringify({
        model: "tts-1",
        voice: "nova", // Change to "alloy", "echo", etc.
        input: text,
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to fetch speech audio");
    }

    const audioBlob = await response.blob();
    const audioUrl = URL.createObjectURL(audioBlob);
    const audio = new Audio(audioUrl);
    const words = text.split(" ");
    let displayedText = "";
    let index = 0

    audio.ontimeupdate = () => {
      if (index < words.length) {
        displayedText += words[index] + " ";
        if (updateLiveText) updateLiveText(displayedText);
        index++;
      }
    };

    audio.play();

    audio.onended = () => {
      if (func) func();
    };
  } catch (error) {
    console.error("TTS Error:", error);
    if (func) func(); // Proceed even if TTS fails
  }
};

export default Speak;
